import { useCallback, useEffect, useMemo, useState } from "react";
import { useObservable } from "micro-observables";

import { setIframeList, tabIndex } from "../../../steps/Three/services/stepThree";

const useIframeBodies = (setCurrentIframeRef, setCurrentIframeWrapperRef) => {
    const [ iFrameList, setIFrameList ] = useState([]);
    const [ iFrameWrapperList, setIFrameWrapperList ] = useState([]);
    const indexActiveTab = useObservable(tabIndex);

    const handleSetIframe = useCallback(
        (iframeRef) => {
            if(iframeRef.current) {
                setIFrameList((prevState) => {
                    if(iframeRef.current && prevState.indexOf(iframeRef.current) === -1) {
                        return [ ...prevState, iframeRef ];
                    }

                    return prevState;
                });
            }
        },
        []
    );

    const handleSetIframeWrapper = useCallback(
        (iframeRef) => {
            if(iframeRef.current) {
                setIFrameWrapperList((prevState) => {
                    if(iframeRef.current && prevState.indexOf(iframeRef.current) === -1) {
                        return [ ...prevState, iframeRef ];
                    }

                    return prevState;
                });
            }
        },
        []
    );

    useEffect(
        () => {
            if(iFrameList[indexActiveTab]) {
                setCurrentIframeRef(iFrameList[indexActiveTab]);
            }

            if(iFrameWrapperList[indexActiveTab]) {
                setCurrentIframeWrapperRef(iFrameWrapperList[indexActiveTab]);
            }
        },
        [ iFrameList, iFrameWrapperList, indexActiveTab, setCurrentIframeRef, setCurrentIframeWrapperRef ]
    );

    useEffect(
        () => {
            setIframeList(iFrameList);
        },
        [ iFrameList ]
    );

    return useMemo(
        () => ({
            indexActiveTab,
            iFrameList,
            iFrameWrapperList,
            onSetIframe: handleSetIframe,
            onSetIframeWrapper: handleSetIframeWrapper
        }),
        [ indexActiveTab, iFrameList, iFrameWrapperList, handleSetIframe, handleSetIframeWrapper ]
    );
};

export default useIframeBodies;
